module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "service-support"
  }, [_c('banner', {
    attrs: {
      "clazz": "service-support-banner",
      "url": "serviceSupport"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "service-support-section1"
  }, [_c('el-tabs', {
    staticClass: "service-support-tab",
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabValue),
      callback: function($$v) {
        _vm.tabValue = $$v
      },
      expression: "tabValue"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "first"
    }
  }, [_c('h1', {
    staticClass: "service-support-tabpane",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("我们的服务")]), _vm._v(" "), _c('div', {
    staticClass: "service"
  }, [_c('div', {
    staticClass: "region1"
  }, [_c('h2', {
    staticClass: "region1-title"
  }, [_vm._v("我们如何帮助您？")]), _vm._v(" "), _c('div', {
    staticClass: "region1-divider"
  }), _vm._v(" "), _c('p', {
    staticClass: "region1-detial"
  }, [_vm._v("\n              甄云提供全流程开发运维服务，帮助企业内部IT能力从面向工具到面向服务的转型，采用前沿技术快速迭代，适应供应链业务前沿需求，涵盖服"), _c('br'), _vm._v("\n              务器、存储、网络、操作系统、应用、中间件及虚拟化的一揽子解决方案，运维专家团队全天候监控、诊断并修复异常，我们的专业服务团队为"), _c('br'), _vm._v("\n              您提供实施运维服务。")])]), _vm._v(" "), _c('div', {
    staticClass: "region2"
  }, [_c('div', {
    staticClass: "region2-content"
  }, [_c('h1', {
    staticClass: "region2-title"
  }, [_vm._v("服务流程")]), _vm._v(" "), _c('div', {
    staticClass: "region2-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "region2-flow"
  }, [_c('ul', {
    staticClass: "flow-ul clearfix"
  }, _vm._l((_vm.flowData), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "flow-li fl"
    }, [_c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.detail))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "region2-detail"
  }, [_c('div', {
    staticClass: "detail-shadow"
  }), _vm._v(" "), _c('img', {
    staticClass: "detail-img",
    attrs: {
      "src": require("../../assets/img/serviceSupport/tab1-region2-2.png"),
      "alt": "服务流程"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('h1', {
    staticClass: "detail-title"
  }, [_vm._v("无论何时何地，只要您需要，都可以获得支持")]), _vm._v(" "), _c('div', {
    staticClass: "detail-divider"
  }), _vm._v(" "), _c('p', {
    staticClass: "detail"
  }, [_vm._v("\n                    当您遇到问题、需求和挑战时，我们都有专人为您服务，"), _c('br'), _vm._v("\n                    保障您问题的及时有效解决，我们很自豪能够成为提供这种"), _c('br'), _vm._v("\n                    个性化支持的提供商。 ")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-contact"
  }, [_vm._v("\n                  我们每一步都与您同在。请致电"), _c('span', {
    staticClass: "phone-number"
  }, [_vm._v(" 400-116-0808 ")]), _vm._v("与我们联系，或留下您的信息，我们\n                  "), _c('button', {
    staticClass: "arrange-demo",
    on: {
      "click": function($event) {
        return _vm.goRegister('fuwuzhichi-yanshi')
      }
    }
  }, [_vm._v("安排演示。")])])])])])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "second"
    }
  }, [_c('h1', {
    staticClass: "service-support-tabpane",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("资料库及常见问题")]), _vm._v(" "), _c('div', {
    staticClass: "exchange"
  }, [_c('div', {
    staticClass: "region1"
  }, [_c('h2', {
    staticClass: "region1-title"
  }, [_vm._v("资料库")]), _vm._v(" "), _c('div', {
    staticClass: "region1-divider"
  }), _vm._v(" "), _c('h2', {
    staticClass: "region1-detial"
  }, [_vm._v("提供行业资讯、采购干货资源下载")]), _vm._v(" "), _c('div', {
    staticClass: "region1-content clearfix"
  }, [_c('div', {
    staticClass: "content content-left fl"
  }, [_c('p', {
    staticClass: "content-detail"
  }, [_vm._v("定期发布行业资讯"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                  采购行业相关干货资源"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                  白皮书、调研报告解读"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                  在这里，能够让您获得更多有价值的资讯")])]), _vm._v(" "), _c('div', {
    staticClass: "content content-right fl"
  }, [_c('img', {
    staticClass: "content-img",
    attrs: {
      "src": require("../../assets/img/serviceSupport/tab3-region1.png"),
      "alt": "采购行业相关干货资源"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "region1-buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.goDocument
    }
  }, [_vm._v("资料下载")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "region2"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', {
    staticClass: "region2-title"
  }, [_vm._v("常见问题")]), _vm._v(" "), _c('div', {
    staticClass: "region2-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "region2-search"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "搜索答案"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.goSearchAnswer.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goSearchAnswer
    }
  })], 1)]), _vm._v(" "), (_vm.tableData.pages) ? _c('div', {
    staticClass: "content"
  }, [_c('el-collapse', {
    staticClass: "tl content-collapse",
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.tableData.question), function(item, index) {
    return _c('el-collapse-item', {
      key: index,
      attrs: {
        "name": index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('h1', {
      staticClass: "collapse-title"
    }, [_c('img', {
      staticClass: "question-icon",
      attrs: {
        "src": require("../../assets/img/serviceSupport/Q.png"),
        "alt": item.subject
      }
    }), _vm._v(_vm._s(item.subject) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "collapse-answer"
    }, [_c('img', {
      staticClass: "answer-icon",
      attrs: {
        "src": require("../../assets/img/serviceSupport/A.png"),
        "alt": item.answer
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "answer-detail"
    }, [_vm._v(_vm._s(item.answer))])])], 2)
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-refresh"
    },
    on: {
      "click": _vm.goChange
    }
  }, [_vm._v(" 换一批")])], 1) : _c('div', {
    staticClass: "content-undefined"
  }, [_c('p', {
    staticClass: "undefined-detail"
  }, [_vm._v("Sorry！很抱歉，我们暂无关于“" + _vm._s(_vm.keywordShow) + "”的相关信息，请您重新输入搜索信息")]), _vm._v(" "), _c('p', {
    staticClass: "undefined-phone"
  }, [_vm._v("或拨打热线：400-116-0808")])])])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-635b47e4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutUs/serviceSupport.vue
// module id = 616
// module chunks = 12